import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/services/global.service';
declare var $: any;
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalAlertService } from 'src/app/services/global-alert.service';
import { Router } from '@angular/router';
//import { io, Socket } from 'socket.io-client';
import { environment } from 'src/environments/environment';
interface NotificationState {
  id: string;
  progress: number;
  message: string;
  type: 'progress' | 'success' | 'error';
}

@Component({
  selector: 'app-gestion-cartera',
  templateUrl: './gestion-cartera.component.html',
  styleUrls: ['./gestion-cartera.component.css']
})
export class GestionCarteraComponent implements OnInit, AfterViewInit {
  @ViewChild('modalSubirCartera', { static: true }) modalSubirCartera!: ElementRef;
  @ViewChild('modalAplicarCartera', { static: true }) modalAplicarCartera!: ElementRef;
  @ViewChild('modalGenerarpdfs', { static: true }) modalGenerarpdfs!: ElementRef;
  private toast: typeof Swal;
  private activeNotifications: Map<string, NotificationState> = new Map();
  public datosProcesados: boolean = false;

  file: File | null = null;
  datosExcel: any[] = [];
  anios: number[] = [];
  mesSeleccionado: number = new Date().getMonth();
  anioSeleccionado: number = new Date().getFullYear();
  meses = [
    { num: 1, nombre: "Enero" },
    { num: 2, nombre: "Febrero" },
    { num: 3, nombre: "Marzo" },
    { num: 4, nombre: "Abril" },
    { num: 5, nombre: "Mayo" },
    { num: 6, nombre: "Junio" },
    { num: 7, nombre: "Julio" },
    { num: 8, nombre: "Agosto" },
    { num: 9, nombre: "Septiembre" },
    { num: 10, nombre: "Octubre" },
    { num: 11, nombre: "Noviembre" },
    { num: 12, nombre: "Diciembre" }
  ];
  opcionSeleccionada: string;
  tipoGeneracion: any;
  //socket: Socket;
  constructor(
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    public alerta: GlobalAlertService,
    public global: GlobalService,
    public router: Router,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 0,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    });
  }

  private showNotification(state: NotificationState) {
    this.activeNotifications.set(state.id, state);

    let toastConfig: any = {
      icon: state.type === 'progress' ? 'info' : state.type,
      title: state.message,
      html: state.type === 'progress' ?
        `<div class="progress" style="height: 5px;">
           <div class="progress-bar" role="progressbar" style="width: ${state.progress}%"></div>
         </div>` : undefined
    };

    if (state.type === 'progress') {
      toastConfig = {
        ...toastConfig,
        allowOutsideClick: true,
        showCloseButton: true,
        didOpen: (toast: any) => {
          const progressBar = toast.querySelector('.progress-bar');
          if (progressBar) {
            progressBar.style.transition = 'width 0.3s ease';
          }
        }
      };
    } else {
      toastConfig.timer = 3000;
    }

    this.toast.fire(toastConfig);
  }

  private updateProgress(id: string, progress: number, message?: string) {
    const state = this.activeNotifications.get(id);
    if (state) {
      state.progress = progress;
      if (message) state.message = message;
      this.showNotification(state);
    }
  }

  ngOnInit(): void {
    this.spinner.show();
    //this.socket = io('https://api-siigo-dispower-629664585428.us-central1.run.app'); 
    const currentYear = new Date().getFullYear();
    this.anios = Array.from({ length: currentYear - 2024 + 1 }, (_, i) => 2024 + i);
  }

  ngAfterViewInit(): void {
    this.spinner.show();
    this.cargarDatos();
  }

  async cargarDatos(): Promise<void> {
    try {
      this.spinner.show();
      const datos = await this.consultarCartera();
      this.datosExcel = Array.isArray(datos[0]) ? datos[0] : datos;

      this.changeDetectorRef.detectChanges();

      // Destruye tabla previa para evitar errores
      if ($.fn.DataTable.isDataTable('#carteraTable')) {
        $('#carteraTable').DataTable().clear().destroy();
      }

      // Inicializa DataTable con datos y oculta spinner en initComplete
      $('#carteraTable').DataTable({
        data: this.datosExcel,
        columns: [
          { data: 'id_cartera', title: 'ID Cartera' },
          { data: 'nui', title: 'NUI' },
          { data: 'id_factura', title: 'Factura' },
          { data: 'name', title: 'Nombre' },
          { data: 'address', title: 'Dirección' },
          { data: 'deuda_anterior', title: 'Valor Total' },
          { data: 'mes_conciliacion', title: 'Mes conciliación' },
          { data: 'ano_conciliacion', title: 'Año conciliación' }
        ],
        responsive: true,
        paging: true,
        pageLength: 25,
        destroy: true,
        language: {
          url: "assets/i18n/Spanish.json"
        },
        initComplete: () => {
          this.spinner.hide();
        }
      });

    } catch (error) {
      console.error("Error al cargar datos:", error);
      this.spinner.hide(); // Oculta spinner si hay error también
    }
  }

  consultarCartera(): Promise<any[]> {
    this.spinner.show();
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => reject('Timeout en consulta'), 60000);

      this.global.consultarServicioProcesarArchivos('ConsultarCartera', {}, (err, data) => {
        clearTimeout(timeout);
        if (err) return reject(err);
        resolve(Array.isArray(data) ? data : []);
      });
    });
  }

  recargar(): void {
    this.spinner.show();
    this.datosExcel = [];
    if ($.fn.DataTable.isDataTable('#carteraTable')) {
      $('#carteraTable').DataTable().clear().destroy();
    }
    this.changeDetectorRef.detectChanges();
    this.cargarDatos();
  }

  verArchivo() {
    window.open("https://php.engenius.com.co/Formatos/Excel/Ejemplo_cartera.xlsx", "_blank");
  }

  abrirModalSubirCartera() {
    this.modalService.open(this.modalSubirCartera, {
      backdrop: 'static',
      keyboard: false
    });
  }

  abrirModalAplicarCartera() {
    this.modalService.open(this.modalAplicarCartera, {
      backdrop: 'static',
      keyboard: false
    });
  }

  abrirModalGenerarpdfs() {
    this.modalService.open(this.modalGenerarpdfs, {
      backdrop: 'static',
      keyboard: false
    });
  }

  onFileChange(event: any) {
    const target: DataTransfer = <DataTransfer>event.target;
    const archivo = target.files[0];
    this.file = archivo;

    Swal.fire({
      icon: 'info',
      title: 'Procesando datos...',
      text: 'Por favor, espera mientras se procesa la información.',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    this.global.consultarServicioCartera(this.file, (error: any, respuesta: any) => {
      Swal.close();

      if (error) {
        console.error("Error al cargar el archivo:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error en el servidor',
          text: 'No se pudo procesar el archivo.',
        });
        return;
      }

      if (respuesta.error) {
        const errores = (respuesta.errores || []).map(e => `- ${e}`);
        const contenidoTxt = `Errores encontrados:\n\n${errores.join('\n')}`;
        const blob = new Blob([contenidoTxt], { type: 'text/plain' });
        const url = window.URL.createObjectURL(blob);

        Swal.fire({
          icon: 'error',
          title: 'Errores en el archivo',
          html: `
          <a href="${url}" download="errores_cargue.txt" style="display:inline-block; margin-top:10px; color:#007bff; text-decoration:underline; cursor:pointer;">
            Descargar errores
          </a>
        `,
          didClose: () => {
            window.URL.revokeObjectURL(url);
          }
        });

        this.datosExcel = [];
        return;
      }

      this.datosExcel = respuesta.datos;
      this.datosProcesados = true;

      Swal.fire({
        icon: 'success',
        title: 'Archivo procesado',
        text: 'El archivo ha sido validado correctamente.',
      });
    });
  }

  enviarDatos() {
    if (this.datosExcel.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Carga de datos',
        text: 'No hay datos para enviar.',
      });
      return;
    }

    Swal.fire({
      icon: 'info',
      title: 'Enviando datos...',
      text: 'Por favor, espera mientras se procesa la información.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.global.consultarServicioProcesarArchivos('insertarCartera', { datos: this.datosExcel }, (error: any, data: any) => {
      Swal.close();
      if (error) {
        console.error("Error al cargar cartera", error);
        Swal.fire({
          icon: 'error',
          title: 'Error en la carga',
          text: 'Ocurrió un error al comunicarse con el servidor.',
        });
        return;
      }

      if (data?.error) {
        Swal.fire({
          icon: 'error',
          title: 'Error en la carga',
          text: data.message || 'Ocurrió un error en el servidor.',
        });
        return;
      }

      Swal.fire({
        icon: 'success',
        title: 'Carga exitosa'
      }).then(() => {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/gestionCartera']);
        });
      });
    });
  }

  private async obtenerIdSolicitudes(mes: number, anio: number): Promise<{ ids: number[], pago_oportuno: string, suspension: string }> {
    return new Promise((resolve, reject) => {
      const datosEnvio = {
        option: "consultar-solicitudes",
        mes: mes,
        anio: anio
      };

      this.global.consultar_siigo(datosEnvio, (error: any, data: any) => {
        if (error) {
          console.error("Error al obtener id_solicitud:", error);
          reject(error);
          return;
        }

        console.log("Datos de solicitudes recibidos:", data);

        const ids = data.ids;
        const pago_oportuno = data.pago_oportuno;
        const suspension = data.suspension;

        console.log("🔍 IDs:", ids);
        console.log("📅 Pago oportuno:", pago_oportuno);
        console.log("📅 Suspensión:", suspension);

        resolve({ ids, pago_oportuno, suspension });
      });
    });
  }

  async generarpdfs() {
    if (!this.mesSeleccionado || !this.anioSeleccionado) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Debe seleccionar el mes y el año.',
      });
      return;
    }

    const processId = `cartera-${Date.now()}`;

    try {
      // Mostrar notificación inicial
      this.showNotification({
        id: processId,
        progress: 0,
        message: 'Iniciando proceso de cartera...',
        type: 'progress'
      });

      // Obtener solicitudes
      this.updateProgress(processId, 20, 'Consultando solicitudes de facturación...');
      const response = await this.obtenerIdSolicitudes(this.mesSeleccionado, this.anioSeleccionado);
      await this.procesarDatapdf(response.ids, response.pago_oportuno, response.suspension);
      if (!response || response.ids.length === 0) {
        this.showNotification({
          id: processId,
          progress: 100,
          message: `No se encontraron solicitudes para ${this.meses.find(m => m.num === this.mesSeleccionado)?.nombre} del ${this.anioSeleccionado}`,
          type: 'error'
        });
        return;
      }
      // Procesar datos
      this.updateProgress(processId, 50, 'Procesando datos consolidados...');

      this.showNotification({
        id: processId,
        progress: 100,
        message: `Pdfs generados exitosamente ${this.meses.find(m => m.num === this.mesSeleccionado)?.nombre} del ${this.anioSeleccionado}`,
        type: 'success'
      });

    } catch (error) {
      console.error('Error al generar pdfs:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al generar pdfs',
      });
    } finally {
      setTimeout(() => {
        this.activeNotifications.delete(processId);
      }, 3000);
    }
  }

  async aplicarCartera() {
    if (!this.mesSeleccionado || !this.anioSeleccionado) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Debe seleccionar el mes y el año.',
      });
      return;
    }

    const processId = `cartera-${Date.now()}`;

    try {
      // Mostrar notificación inicial
      this.showNotification({
        id: processId,
        progress: 0,
        message: 'Iniciando proceso de cartera...',
        type: 'progress'
      });

      // Obtener solicitudes
      this.updateProgress(processId, 20, 'Consultando solicitudes de facturación...');
      const response = await this.obtenerIdSolicitudes(this.mesSeleccionado, this.anioSeleccionado);

      if (!response || response.ids.length === 0) {
        this.showNotification({
          id: processId,
          progress: 100,
          message: `No se encontraron solicitudes para ${this.meses.find(m => m.num === this.mesSeleccionado)?.nombre} del ${this.anioSeleccionado}`,
          type: 'error'
        });
        return;
      }

      // Procesar datos
      this.updateProgress(processId, 50, 'Procesando datos consolidados...');

      console.log("Prueba que Pasa",response.ids)
      await this.procesarDataConsolidada(response.ids);
      
      this.showNotification({
        id: processId,
        progress: 100,
        message: `Cartera aplicada exitosamente para ${this.meses.find(m => m.num === this.mesSeleccionado)?.nombre} del ${this.anioSeleccionado}`,
        type: 'success'
      });

    } catch (error) {
      console.error('Error al aplicar cartera:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error en la carga',
        text: 'Error al cargar aplicar la cartera',
      });
    } finally {
      setTimeout(() => {
        this.activeNotifications.delete(processId);
      }, 3000);
    }
  }

  private async procesarDataConsolidada(idSolicitudes: number[]): Promise<void> {
    const processId = `consolidacion-${Date.now()}`;
    console.log("📤 Enviando solicitud para procesar data consolidada...");

    this.showNotification({
      id: processId,
      progress: 0,
      message: "Iniciando la aplicación de la cartera",
      type: "progress",
    });

    return new Promise((resolve, reject) => {
      let tipoCartera: string;
      let tipoSolicitud: string;

      switch (this.opcionSeleccionada) {
        case 'normal':
          tipoCartera = 'Data_consolidada_Normal';
          tipoSolicitud = 'Normal'
          break;
        case 'sedes':
          tipoCartera = 'Data_consolidada_Sedes';
          break;
        case 'saldo':
          tipoCartera = 'Data_consolidada_Saldo';
          break;
        case 'La victoria':
          tipoCartera = 'Data_consolidada_Normal';
          tipoSolicitud = 'La victoria'

          break;
        default:
          tipoCartera = 'Data_consolidada_Normal';
          break;
      }


      const datosEnvio = {
        option: tipoCartera,
        id_solicitud: idSolicitudes.join(","),
        tipo_solicitud: tipoSolicitud,
      };
      console.log("Datos envio",datosEnvio.id_solicitud)


      // // Escuchar progreso emitido por el backend
      // this.socket.on('progreso', (data) => {
      //   const porcentaje = Math.round((data.iteracion / data.total) * 100);
      //   this.updateProgress(processId, porcentaje, `Procesando (${data.iteracion}/${data.total})...`);
      // });

      this.global.consultar_siigo(datosEnvio, (error: any, data: any) => {
        //Detener escucha al finalizar
        //this.socket.off('progreso');

        if (error) {
          console.error("Error al procesar data consolidada:", error);
          this.showNotification({
            id: processId,
            progress: 100,
            message: "Error en la consolidación de datos",
            type: "error",
          });
          reject(error);
          return;
        }

        console.log("Data consolidada procesada:", data);

        this.showNotification({
          id: processId,
          progress: 100,
          message: "Aplicación exitosa de la cartera",
          type: "success",
        });

        resolve();
      });
    });
  }

  private async procesarDatapdf(idSolicitudes: number[], pago_oportuno: string, suspension: string): Promise<void> {
    const processId = `consolidacion-${Date.now()}`;
    console.log("📤 Enviando solicitud para procesar facturas...");

    this.showNotification({
      id: processId,
      progress: 0,
      message: "Iniciando la creación de PDFs",
      type: "progress",
    });

    return new Promise((resolve, reject) => {
      const datosEnvio = {
        option: "Generator-pdf-new-sstf",
        id_solicitud: idSolicitudes.join(","), // para tipo normal
        mes: this.mesSeleccionado,
        anio: this.anioSeleccionado,
        tipo: this.tipoGeneracion,
        pago_oportuno_fijo: pago_oportuno,
        suspension_fijo: suspension
      };
      console.log("pagooportuno", datosEnvio.pago_oportuno_fijo)
       // Escuchar progreso emitido por el backend
      // this.socket.on('progreso', (data) => {
      //   const porcentaje = Math.round((data.iteracion / data.total) * 100);
      //   this.updateProgress(processId, porcentaje, `Procesando (${data.iteracion}/${data.total})...`);
      // });

      this.global.consultar_siigo(datosEnvio, (error: any, data: any) => {
        //Detener escucha al finalizar
        //this.socket.off('progreso');
        if (error) {
          console.error("Error al generar los PDFs:", error);
          this.showNotification({
            id: processId,
            progress: 100,
            message: "Error en la generación de los PDFs",
            type: "error",
          });
          reject(error);
          return;
        }

        console.log("Datos procesados:", data);

        this.showNotification({
          id: processId,
          progress: 100,
          message: "Generación de los PDFs exitosa",
          type: "success",
        });

        resolve();
      });
    });
  }
}
